import axios from 'axios';

import { getSentryUtil } from '../../main/utils/monitoring/sentry.util.ts';

import { MagicLinkTokenRequest, MagicLinkTokenResponse } from '../types/magic-link.types.ts';

export const magicTokenLoginRequest = async (
  url: string,
  magicToken: string
): Promise<MagicLinkTokenResponse | undefined> => {
  try {
    const request: MagicLinkTokenRequest = {
      magicToken,
    };
    const response = await axios.post<MagicLinkTokenResponse>(url, request);
    return response.data;
  } catch (error) {
    getSentryUtil().trackError(error as Error, { url, magicToken });
    return;
  }
};
